import styled from 'styled-components';

export const StyledInputWrapper = styled.div`
  position: relative;
  z-index: 11;
`;

export const StyledInputSearchIcon = styled.div`
  position: absolute;
  top: 50%;
  left: 16px;
  transform: translateY(-50%);
  color: var(--textGrey);
  z-index: 1;
  pointer-events: none;
  font-size: 14px;
`;

export const StyledInput = styled.input`
  position: relative;
  width: 100%;
  height: 48px;
  border: none;
  background-color: var(--bgLightGrey);
  color: var(--textDark);
  padding: 0 20px 0 41px;
  box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.1) inset;
  
  &::placeholder {
    color: var(--textGrey);
  }
  
  &:focus {
    outline: none;
    box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.15) inset;
  }
`;
